// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__DwtSp","spinLoader":"Loader_spinLoader__IOwM3"};